var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup26689(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_26689",
    "data-name": "Group 26689",
    transform: "translate(-236 -885)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_238",
    "data-name": "Ellipse 238",
    cx: 36,
    cy: 36,
    r: 36,
    transform: "translate(236 885)",
    fill: "#1ab3c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23260",
    "data-name": "Path 23260",
    d: "M899.336,96.161a1.174,1.174,0,0,0,1.172,1.172H929.82a2.345,2.345,0,1,1,0,4.69H900.508a5.862,5.862,0,0,1-5.862-5.862V71.539a2.345,2.345,0,1,1,4.69,0Zm20.416-8.9a2.339,2.339,0,0,1-3.312,0l-4.207-4.2-6.551,6.544A2.342,2.342,0,0,1,902.37,86.3l8.207-8.207a2.339,2.339,0,0,1,3.312,0l4.206,4.2,7.724-7.716a2.342,2.342,0,0,1,3.312,3.312Z",
    transform: "translate(-641.646 835.806)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup26689);
export default __webpack_public_path__ + "static/media/Group 26689.62a758c0fac9976dac615215a6c880ec.svg";
export { ForwardRef as ReactComponent };